import * as React from 'react'
import { Box } from '@mui/material'

import { ImageSkuBlock, SkuInfoBlock } from '@components'
import { useBuildExternalURL } from '@hooks'
import {formatDate} from "@ui-seeker/utils";


export default function productNameColumn() {
	return [
		{
			name: 'category',
			label: 'Category',
			options: {
				display: 'excluded',
				customBodyRowRender: value => value
			}
		}, {
			name: 'brand',
			label: 'Brand',
			options: {
				display: 'excluded',
				customBodyRowRender: value => value
			}
		}, {
			name: 'skuName',
			label: 'Product Name',
			options: {
				display: 'excluded',
				filterType: 'textField',
				customBodyRowRender: value => value
			}
		},{
			name: 'date',
			label: 'Date',
			options: {
				display: 'excluded',
				customBodyRowRender: value => formatDate(value, { isString: true })
			}
		}, {
			name: 'skuName',
			label: 'Product Name',
			options: {
				headerAlign: 'left',
				filter: false,
				customBodyRowRenderLite: (value, { category, brand, ean, skuID, productID, siteID, date, brandId, reference }) => {
					const { imageURL, productURL } = useBuildExternalURL({
						imageData: { skuID, siteID, productID, date },
						siteData: { siteID, productID }
					})

					return <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
						<Box>
							<ImageSkuBlock imageURL={imageURL} />
						</Box>
						<Box>
							<SkuInfoBlock
								sku={value}
								category={category}
								brand={brand}
								ean={ean}
								brandId={brandId}
								reference={reference}
								productURL={productURL}
							/>
						</Box>
					</Box>
				}
			}
		}
	]
}